import metricsOverviewQuery, {
	type PerformanceOverviewMainQuery,
} from '@jira/admin-pages__performance/src/__generated__/PerformanceOverviewMainQuery.graphql';
import type { PreloadedQuery } from 'react-relay';
import { fg } from '@atlassian/jira-feature-gating';
// eslint-disable-next-line jira/import-whitelist
import { createRelayResource } from '@jira/platform__graphql-relay-utils/src/services/resources/index.tsx';
import type { RouteResource } from '@atlassian/react-resource-router';

export const metricsOverviewPageResource: RouteResource<
	PreloadedQuery<PerformanceOverviewMainQuery, Record<string, unknown>>
> = createRelayResource<PerformanceOverviewMainQuery>({
	type: 'ADMIN_PAGES_PERFORMANCE_OVERVIEW',
	getQuery: (_, { tenantContext }) => ({
		parameters: metricsOverviewQuery,
		variables: {
			cloudId: tenantContext.cloudId,
			schemaMigrationEnabled: fg('site_optimiser_schema_migration'),
			projectLevelReportingEnabled: fg('slt1-682-fe-project-level-reporting-so'),
			siteOptimizerAddCfoIslMetricsEnabled: fg('slt1-1341_site_optimizer_add_cfo_isl_metrics'),
		},
		options: {
			fetchPolicy: 'network-only',
		},
	}),
});
